import {
  Grid,
  List,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { memo, useState } from "react";
import { isEmpty } from "lodash";
import clsx from "clsx";

const CustomList = (props) => {
  const { lang, data, page, value } = props;
  const [checked, setChecked] = useState([0]);
  const handleToggle = (id, name) => {
    const currentIndex = checked.indexOf(id);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
    const check = checked.indexOf(id) !== -1;
    change(name, id, !check);
  };
  const change = (name, id, check) => {
    if (props.onChange) {
      props.onChange(name, id, check);
    }
  };
  return (
    <>
      <List
        sx={{ width: "100%", maxWidth: "100%", bgcolor: "background.paper" }}
      >
        {page === "income" ? (
          data?.map(({ Mfnc_Id, Mfnc_NameEn, Mfnc_NameTh }) => {
            if (!isEmpty(value)) {
              value.forEach((ele) => {
                if (
                  ele === Mfnc_NameEn ||
                  (ele.includes("Other") && Mfnc_NameEn.includes("Other"))
                ) {
                  const curIndex = checked.indexOf(Mfnc_Id);
                  const newChecked = [...checked];
                  if (curIndex === -1) {
                    newChecked.push(Mfnc_Id);
                    setChecked(newChecked);
                  }
                }
              });
            }
            return (
              <Grid key={Mfnc_Id}>
                <FormControlLabel
                  onChange={(e) => {
                    handleToggle(Mfnc_Id, Mfnc_NameEn);
                  }}
                  classes={{
                    label: clsx("font-20 text-black font-DBHeavent"),
                  }}
                  control={
                    <Checkbox checked={checked.indexOf(Mfnc_Id) !== -1} />
                  }
                  label={lang === "th" ? Mfnc_NameTh : Mfnc_NameEn}
                />
              </Grid>
            );
          })
        ) : page === "purpose" ? (
          data?.map(({ SAmpp_Id, SAmpp_EnName, SAmpp_Name }) => {
            if (!isEmpty(value)) {
              value.forEach((ele) => {
                if (ele === SAmpp_Id.toString()) {
                  const curIndex = checked.indexOf(SAmpp_Id);
                  const newChecked = [...checked];
                  if (curIndex === -1) {
                    newChecked.push(SAmpp_Id);
                    setChecked(newChecked);
                  }
                }
              });
            }
            return (
              <Grid key={SAmpp_Id}>
                <FormControlLabel
                  onChange={(e) => {
                    handleToggle(SAmpp_Id, SAmpp_EnName);
                  }}
                  classes={{
                    label: clsx("font-20 text-black font-DBHeavent"),
                  }}
                  control={
                    <Checkbox checked={checked.indexOf(SAmpp_Id) !== -1} />
                  }
                  label={lang === "th" ? SAmpp_Name : SAmpp_EnName}
                />
              </Grid>
            );
          })
        ) : (
          <Grid></Grid>
        )}
      </List>
    </>
  );
};

export default memo(CustomList);
